import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { InlineSVGModule } from 'ng-inline-svg';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainMenuComponent } from './shared/main-menu/main-menu.component';
import { TopFooterComponent } from './shared/top-footer/top-footer.component';
import { BottomFooterComponent } from './shared/bottom-footer/bottom-footer.component';
import { LeadComponent } from './shared/lead/lead.component';
import { AboutComponent } from './about/about.component';
import { GymComponent } from './gym/gym.component';
import { PartysComponent } from './partys/partys.component';
import { StableComponent } from './stable/stable.component';
import { HeaderComponent } from './shared/header/header.component';
import { InstructorsComponent } from './stable/components/instructors/instructors.component';
import { JogaComponent } from './joga/joga.components';

@NgModule({
  declarations: [
    AppComponent,
    MainMenuComponent,
    TopFooterComponent,
    BottomFooterComponent,
    LeadComponent,
    AboutComponent,
    GymComponent,
    PartysComponent,
    StableComponent,
    HeaderComponent,
    InstructorsComponent,
    JogaComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    InlineSVGModule.forRoot()
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
